import {BillDiscount, BillDiscountRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";


export const BillDiscountListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(BillDiscountRestControllerApiFactory);

	const listConfig: AppListConfig<BillDiscount> = {
		title: "Descuentos",
		onClick: "/app/admin/billing/discount",
		headers: [
			{title:"Nombre"}
		],
		decorator: (bean: BillDiscount) => (
			<>
				<TableCell sx={{fontWeight: 600}}>
					{bean.name || "—"}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			return ctrl.pageBillDiscount(
				currentPage,
				size,
				undefined,
				term,
				showDismissed
			);
		}
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
